import React, { FC } from "react";
import { Flex, Spin } from "antd";

export const TableLoader: FC = () => (
    <Flex style={{ height: "100%", width: "100%" }} justify="center" align="center">
        <Spin size="large" />
    </Flex>
);
